const TransferAutographFooter = () => {
  return (
    <>
      <div className="autograph-container autograph-container-3">
        <div>
          <div className="autograph-line"></div>
          <div className="autograph-title">Supir</div>
        </div>

        <div>
          <div className="autograph-line"></div>
          <div className="autograph-title">Petugas Gudang</div>
        </div>

        <div>
          <div className="autograph-line"></div>
          <div className="autograph-title">Penerima</div>
        </div>
      </div>
    </>
  );
};

export default TransferAutographFooter;
